import { HeadsetIcon } from 'lucide-react';

import { defineModule } from '@/shared/registry/types';

import { OpenlinesSearchResult } from './components/SearchResult';
import { OpenlinesTopBarButton } from './components/TopBarButton';
import { useIsOperator, useWaitingCount } from './hooks';
import { setupOpenlinesRealtime } from './realtime';

/**
 * `openlines` module (docs/modules/openlines.md): client dialogs from the site widget and messengers. Operators work in
 * the messenger (`/messenger/openlines/:sessionId?`, the "Open lines" tab of its left pane); lines, channels, quick
 * answers, statistics and the dev simulator live in the contact center (`/contact-center/*`).
 */
export const module = defineModule({
  id: 'openlines',
  routes: [
    {
      path: 'messenger/openlines/:sessionId?',
      handle: { layout: 'full' },
      lazy: async () => ({ Component: (await import('./pages/OpenlinesMessengerPage')).default }),
    },
    {
      path: 'contact-center/*',
      lazy: async () => ({ Component: (await import('./pages/ContactCenterPage')).default }),
    },
  ],
  nav: [
    {
      id: 'openlines',
      labelKey: 'openlines:nav.title',
      icon: HeadsetIcon,
      to: '/contact-center',
      order: 25,
      section: 'main',
      useCounter: useWaitingCount,
      useVisible: useIsOperator,
    },
  ],
  messengerTabs: [
    {
      id: 'openlines',
      labelKey: 'openlines:messengerTab',
      icon: HeadsetIcon,
      to: '/messenger/openlines',
      order: 10,
      useCounter: useWaitingCount,
      useVisible: useIsOperator,
    },
  ],
  topBarWidgets: [{ id: 'openlines', order: 15, component: OpenlinesTopBarButton }],
  searchRenderers: { session: OpenlinesSearchResult },
  setup: ({ queryClient, realtime }) => setupOpenlinesRealtime(queryClient, realtime),
});
